import styled from 'styled-components';
import { device } from 'helpers/breakpoints';

const IntroContainer = styled.div`
    max-width: 650px;
    padding: 1rem;
    text-align: center;
    
    @media ${device.mobileL} { 
      padding-left: 2rem;
      padding-right: 2rem;
    }
    
    @media ${device.laptopL} { 
      padding-left: 0;
      padding-right: 0;
    }
    
    h2 {
        font-size: 1.5rem;
        margin-bottom: 1em;
    }
`;

const ProdLogoImg = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
    gap: 40px;
    
    img {
      height: 90px;
    }

    @media ${device.tablet} {
        img {
          height: 100px;
        }
     
    }
`

const Description = styled.div`
    margin-bottom: 3rem;
`

const CtaLinks =  styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    margin-top: 2rem;
    gap: 25px;
    
    .btn__cta {
      margin-bottom: 1rem;
    }
    
    @media ${device.mobileL} {
      margin-top: 4rem;
      margin-bottom: 4rem;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding-left: 0;
      padding-right: 0;
    
      .btn__cta {
        margin-bottom: 0;
      }
    }
`

export {IntroContainer, ProdLogoImg, Description, CtaLinks}
